// extracted by mini-css-extract-plugin
export default {"confirm_and_pay":"confirmAndPay_confirm_and_pay__h6Ph8","confirm":"confirmAndPay_confirm__2FlQo","add_payment":"confirmAndPay_add_payment__EmxAV"};